export const GA_SECTION_NAMES = {
  EPG: 'Programación',
  SERIE: 'Serie',
  MOVIE: 'Pelicula',
  SEARCH: 'Buscador',
  SPORTS: 'Deportes',
};
